// API Service - Dashboard HQ Control
// Backend: FastAPI + PostgreSQL (port 8000)

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// ─── Mock data (shown when backend is not connected) ───────────────────────
const MOCK_DATA = {
  '/agents': [
    { id: 'alpha', nome: 'Alpha', cargo: 'Orchestrator', ativo: true, default_model: 'gpt-4o', color: '#6366f1', emoji: '🤖', config: { color: '#6366f1', emoji: '🤖' } },
    { id: 'beta',  nome: 'Beta',  cargo: 'Developer',    ativo: true, default_model: 'gpt-4o', color: '#22c55e', emoji: '💻', config: { color: '#22c55e', emoji: '💻' } },
    { id: 'gamma', nome: 'Gamma', cargo: 'Analyst',      ativo: true, default_model: 'gpt-4o', color: '#f59e0b', emoji: '🔍', config: { color: '#f59e0b', emoji: '🔍' } },
  ],
  '/projects': [
    { id: 1, nome: 'Project Alpha', status: 'ativo',       objetivo: 'Main product development', responsavel_agente: 'alpha', criado_em: new Date().toISOString(), atualizado_em: new Date().toISOString() },
    { id: 2, nome: 'Project Beta',  status: 'producao',    objetivo: 'Infrastructure setup',     responsavel_agente: 'beta',  criado_em: new Date().toISOString(), atualizado_em: new Date().toISOString() },
    { id: 3, nome: 'Project Gamma', status: 'planejamento',objetivo: 'Research & discovery',     responsavel_agente: 'gamma', criado_em: new Date().toISOString(), atualizado_em: new Date().toISOString() },
  ],
  '/tasks': [
    { id: 1, titulo: 'Design system setup',    status: 'implementacao', prioridade: 1, projeto_id: 1, responsavel_id: 'alpha', criado_em: new Date().toISOString(), atualizado_em: new Date().toISOString() },
    { id: 2, titulo: 'API integration',        status: 'planejado',     prioridade: 2, projeto_id: 1, responsavel_id: 'beta',  criado_em: new Date().toISOString(), atualizado_em: new Date().toISOString() },
    { id: 3, titulo: 'Database migration',     status: 'concluido',     prioridade: 1, projeto_id: 2, responsavel_id: 'beta',  criado_em: new Date().toISOString(), atualizado_em: new Date().toISOString() },
    { id: 4, titulo: 'User research',          status: 'planejado',     prioridade: 3, projeto_id: 3, responsavel_id: 'gamma', criado_em: new Date().toISOString(), atualizado_em: new Date().toISOString() },
    { id: 5, titulo: 'Performance audit',      status: 'implementacao', prioridade: 2, projeto_id: 2, responsavel_id: 'gamma', criado_em: new Date().toISOString(), atualizado_em: new Date().toISOString() },
  ],
  '/stats': {
    active_projects: 3,
    pending_tasks: 3,
    completed_tasks: 1,
    active_agents: 3,
    total_runs: 42,
    total_queues: 2,
  },
  '/security/summary': {
    logs_24h: 5,
    alertas_criticos: 0,
    alertas_altos: 0,
    alertas_medios: 1,
    tentativas_ataque_externas_24h: 0,
    processos_monitorados: 3,
    vulnerabilidades_ativas: 1,
    total_logs: 5,
    critical: 0,
    warning: 1,
    info: 4,
  },
  '/security/logs': [
    { id: 1, tipo: 'acesso', severidade: 'INFO',   origem: 'agent:alpha', mensagem: 'Authentication successful',      timestamp: new Date().toISOString(), detalhes: {} },
    { id: 2, tipo: 'acesso', severidade: 'INFO',   origem: 'agent:beta',  mensagem: 'Task execution started',         timestamp: new Date().toISOString(), detalhes: {} },
    { id: 3, tipo: 'sistema',severidade: 'AVISO',  origem: 'system',      mensagem: 'Memory usage above 70%',         timestamp: new Date().toISOString(), detalhes: {} },
    { id: 4, tipo: 'acesso', severidade: 'INFO',   origem: 'agent:gamma', mensagem: 'Report generated successfully',   timestamp: new Date().toISOString(), detalhes: {} },
    { id: 5, tipo: 'sistema',severidade: 'INFO',   origem: 'system',      mensagem: 'Scheduled backup completed',     timestamp: new Date().toISOString(), detalhes: {} },
  ],
  '/security/vulnerabilities': [
    { id: 1, tipo: 'dependency', severidade: 'BAIXO', componente: 'react-scripts', versao_afetada: '5.0.1', descricao: 'Outdated dev dependency', cve: null, corrigido: false, descoberta_em: new Date().toISOString() },
  ],
  '/queues': [
    { id: 1, nome: 'task-queue',   descricao: 'Main task processing queue', status: 'active', criado_em: new Date().toISOString() },
    { id: 2, nome: 'report-queue', descricao: 'Report generation queue',     status: 'active', criado_em: new Date().toISOString() },
  ],
  '/runs': [
    { id: 1, agent_id: 'alpha', model_used: 'gpt-4o', status: 'completed', started_at: new Date().toISOString(), finished_at: new Date().toISOString(), input_prompt: 'Analyze project status', output: 'All systems nominal.', metadados: {} },
    { id: 2, agent_id: 'beta',  model_used: 'gpt-4o', status: 'completed', started_at: new Date().toISOString(), finished_at: new Date().toISOString(), input_prompt: 'Run database migration', output: 'Migration completed successfully.', metadados: {} },
    { id: 3, agent_id: 'gamma', model_used: 'gpt-4o', status: 'completed', started_at: new Date().toISOString(), finished_at: new Date().toISOString(), input_prompt: 'Generate weekly report', output: 'Report ready.', metadados: {} },
  ],
  '/memory': [],
  '/activities': [],
  '/public/memories': [],
  '/public/activities': [],
};

function getMock(endpoint) {
  // Match by prefix (e.g. /tasks?status=x still hits /tasks mock)
  const key = Object.keys(MOCK_DATA).find(k => endpoint === k || endpoint.startsWith(k + '?') || endpoint.startsWith(k + '/'));
  return key ? MOCK_DATA[key] : null;
}

class ApiService {
  async request(endpoint, options = {}) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(`${API_URL}${endpoint}`, config);
      
      // Handle 204 No Content (DELETE success)
      if (response.status === 204) {
        return null;
      }
      
      if (!response.ok) {
        const error = await response.json().catch(() => ({ 
          code: 'UNKNOWN_ERROR',
          message: `HTTP ${response.status}` 
        }));
        throw new Error(error.message || error.detail || `HTTP ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API Request Error:', error);
      // Fallback to mock data when backend is not available
      const mock = getMock(endpoint);
      if (mock !== null) {
        console.warn(`[mock] ${endpoint}`);
        return mock;
      }
      throw error;
    }
  }

  // ===== AGENTS =====
  async getAgents() {
    const agents = await this.request('/agents');
    // Normalizar estrutura de dados do backend
    return agents.map(agent => ({
      id: agent.id,
      name: agent.nome || agent.name,
      specialty: agent.cargo || agent.specialty,
      enabled: agent.ativo,
      ativo: agent.ativo, // Manter compatibilidade com HomePage
      default_model: agent.default_model,
      color: agent.color,
      emoji: agent.emoji,
      avatar: (() => {
        const a = agent.avatar;
        if (!a) return `https://api.dicebear.com/7.x/bottts/svg?seed=${agent.id}`;
        if (/^https?:\/\//i.test(a)) return a;
        return `${API_URL}${a.replace(/^\/api/, '')}`;
      })(),
      handbook_path: `/handbooks/${agent.id}.md`,
      permissions: typeof agent.permissions === 'string' 
        ? JSON.parse(agent.permissions) 
        : agent.permissions || []
    }));
  }

  // ===== PROJECTS =====
  async getProjects() {
    const projects = await this.request('/projects');
    // Normalizar estrutura de dados do backend
    return projects.map(project => ({
      id: project.id,
      name: project.nome,
      status: project.status,
      goal: project.objetivo || project.descricao || '',
      notes: project.notas || '',
      agent_id: project.responsavel_agente,
      created_at: project.criado_em,
      updated_at: project.atualizado_em
    }));
  }

  async getProject(id) {
    // Projects view doesn't have single-item endpoint, filter client-side
    const projects = await this.getProjects();
    return projects.find(p => p.id === parseInt(id));
  }

  async createProject(data) {
    // Mapear campos do frontend para backend
    const backendData = {
      nome: data.name || data.nome,
      descricao: data.goal || data.descricao || '',
      status: data.status || 'ativo',
      responsavel_agente: data.agent_id || data.responsavel_agente || 'main',
    };
    return this.request('/projects', {
      method: 'POST',
      body: JSON.stringify(backendData),
    });
  }

  async updateProject(id, data) {
    // Mapear campos do frontend para backend
    const backendData = {};
    if (data.name !== undefined) backendData.nome = data.name;
    if (data.goal !== undefined) backendData.descricao = data.goal;
    if (data.status !== undefined) backendData.status = data.status;
    if (data.agent_id !== undefined) backendData.responsavel_agente = data.agent_id;
    
    return this.request(`/projects/${id}`, {
      method: 'PUT',
      body: JSON.stringify(backendData),
    });
  }

  async deleteProject(id) {
    return this.request(`/projects/${id}`, {
      method: 'DELETE',
    });
  }

  // ===== TASKS =====
  async getTasks(filters = {}) {
    const params = new URLSearchParams();
    if (filters.project_id) params.append('project_id', filters.project_id);
    if (filters.status) params.append('status', filters.status);
    
    const query = params.toString();
    const tasks = await this.request(`/tasks${query ? '?' + query : ''}`);
    
    // Normalizar estrutura de dados do backend
    return tasks.map(task => ({
      id: task.id,
      title: task.titulo,
      desc: task.descricao || '',
      status: task.status,
      priority: task.prioridade || 3,
      risk_level: task.nivel_risco || 'medium',
      owner_agent: task.responsavel_id,
      project_id: task.projeto_id,
      created_at: task.criado_em,
      updated_at: task.atualizado_em,
      completed_at: task.concluido_em
    }));
  }

  async getTask(id) {
    // Tasks view doesn't have single-item endpoint, filter client-side
    const tasks = await this.getTasks();
    return tasks.find(t => t.id === parseInt(id));
  }

  async createTask(data) {
    // Mapear campos do frontend para backend
    const backendData = {
      titulo: data.title || data.titulo,
      descricao: data.desc || data.descricao || '',
      prioridade: data.priority || data.prioridade || 3,
      status: data.status || 'planejado',
      projeto_id: data.project_id || data.projeto_id,
      responsavel_id: data.owner_agent || data.responsavel_id || null,
    };
    return this.request('/tasks', {
      method: 'POST',
      body: JSON.stringify(backendData),
    });
  }

  async updateTask(id, data) {
    // Mapear campos do frontend para backend
    const backendData = {};
    if (data.title !== undefined) backendData.titulo = data.title;
    if (data.desc !== undefined) backendData.descricao = data.desc;
    if (data.priority !== undefined) backendData.prioridade = data.priority;
    if (data.status !== undefined) backendData.status = data.status;
    if (data.owner_agent !== undefined) backendData.responsavel_id = data.owner_agent;
    if (data.risk_level !== undefined) backendData.nivel_risco = data.risk_level;
    
    return this.request(`/tasks/${id}`, {
      method: 'PUT',
      body: JSON.stringify(backendData),
    });
  }

  async deleteTask(id) {
    return this.request(`/tasks/${id}`, {
      method: 'DELETE',
    });
  }

  // Kanban drag-and-drop
  async moveTask(id, newStatus) {
    return this.request(`/tasks/${id}/move`, {
      method: 'PATCH',
      body: JSON.stringify({ status: newStatus }),
    });
  }

  // ===== SECURITY (SYS) =====
  async getSecurityLogs(limit = 100) {
    const logs = await this.request(`/security/logs?limit=${limit}`);
    // Normalizar estrutura de dados do backend
    return logs.map(log => {
      // Mapear severidade para level esperado pelo frontend
      const severityMap = {
        'CRITICO': 'critical',
        'ALTO': 'warning', 
        'MEDIO': 'warning',
        'BAIXO': 'info',
        'INFO': 'info'
      };
      
      // Inferir categoria do tipo
      const categoryMap = {
        'ATUALIZACAO_KERNEL': 'update',
        'TENTATIVA_ACESSO': 'intrusion',
        'FIREWALL_BLOQUEIO': 'firewall',
        'DISCO_CHEIO': 'disk',
        'CPU_ALTO': 'resource',
        'MEMORIA_ALTA': 'resource',
        'BACKUP_FALHA': 'backup',
        'SSL_EXPIRANDO': 'ssl'
      };
      
      return {
        id: log.id,
        timestamp: log.timestamp,
        level: severityMap[log.severidade] || 'info',
        category: categoryMap[log.tipo] || 'intrusion',
        source: log.origem,
        message: log.mensagem,
        resolved: log.resolvido !== undefined ? log.resolvido : true // Default true se não especificado
      };
    });
  }

  async getSecuritySummary() {
    const summary = await this.request('/security/summary');
    // Backend já retorna no formato esperado pelo frontend:
    // total_events, critical, blocked_ips, unresolved, processos_monitorados, tentativas_ataque_24h, vulnerabilidades_ativas
    return summary;
  }

  // ===== VULNERABILITIES =====
  async getVulnerabilities(activeOnly = true) {
    return this.request(`/security/vulnerabilities?active_only=${activeOnly}`);
  }

  // ===== QUEUES =====
  async getQueues() {
    return this.request('/queues');
  }
  
  async getWorkItems(limit = 100) {
    // Work items não tem endpoint dedicado ainda
    // Retornar mock data vazio por enquanto
    return [];
  }
  
  async updateWorkItem(id, data) {
    // Endpoint ainda não implementado
    throw new Error('Work items update endpoint not implemented');
  }

  // ===== RUNS =====
  async getRuns(limit = 100) {
    const runs = await this.request(`/runs?limit=${limit}`);
    // Se backend retornar dados, normalizar se necessário
    return runs.map(run => ({
      id: run.id,
      session_key: run.session_key || run.id,
      agent_id: run.agent_id || run.agente_id,
      status: run.status,
      model_used: run.model_used || run.modelo,
      duration_ms: run.duration_ms || run.duracao_ms,
      summary: run.summary || {},
      error: run.error || null,
      task_id: run.task_id || run.tarefa_id,
      created_at: run.created_at || run.criado_em
    }));
  }
  
  async createRun(data) {
    return this.request('/runs', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  // ===== HEALTH CHECKS =====
  async checkHealth() {
    return this.request('/health');
  }

  async checkReady() {
    return this.request('/ready');
  }

  // ===== PUBLIC MEMORIES =====
  async getPublicMemories(limit = 50, agentId = null) {
    const params = new URLSearchParams();
    params.append('limit', limit);
    if (agentId) params.append('agent_id', agentId);
    return this.request(`/public/memories?${params.toString()}`);
  }

  // ===== PUBLIC ACTIVITIES =====
  async getPublicActivities(limit = 50, agentId = null) {
    const params = new URLSearchParams();
    params.append('limit', limit);
    if (agentId) params.append('agent_id', agentId);
    return this.request(`/public/activities?${params.toString()}`);
  }

  // ===== STATS (Server-side calculated) =====
  async getStats() {
    // Backend endpoint /api/stats calcula estatísticas corretamente:
    // - Conta apenas tarefas de projetos ativos
    // - Evita fetch de todas tasks (mais eficiente)
    return this.request('/stats');
  }
}

export const apiService = new ApiService();
export default apiService;
